import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import LandingPage from './components/LandingPage';
import ClientIntakeForm from './components/ClientIntakeForm';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Heebo, Arial, sans-serif',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700',
    },
    secondary: {
      main: '#B8860B',
    },
    background: {
      default: '#000000',
      paper: '#0a0a0a',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/intake" element={<ClientIntakeForm />} />
          <Route path="/form" element={<ClientIntakeForm />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
